exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-parceiro{padding: 0px 25px;width: 250px !important;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/rel-extrato-contrato/rel-extrato-contrato.component.css
// module id = ../../../../../src/app/componentes/rel-extrato-contrato/rel-extrato-contrato.component.css
// module chunks = main